// import './css/service-edit.css';

import React from 'react';
import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { ActionType } from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';
import ModalScreen from 'component/ModalScreen';

class TerminateServiceModal extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      min_dtm: new Date(props.min_dtm),
      end_dtm: new Date(),
      reason_id: 0,
      remarks: '',
      error: '',
    }
    this.submitModal = this.submitModal.bind(this);
  }

  setEndDate(end_dtm)
  {
    this.setState({end_dtm});
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let service = {...this.props.service, action: ActionType.Terminate};
    service.start_dtm = Util.ShortDate(service.start_dtm);
    service.end_dtm   = Util.ShortDate(this.state.end_dtm);
    service.remarks   = this.state.remarks;
    service.reason_id = this.state.reason_id;

    API.changeServiceRecord(service).then(resp =>
    {
      if (!resp.success)
        PopMessage.show(resp.msg, '資料存取失敗', 'danger');
      else
      {
        PopMessage.show('已存儲暫停服務記錄', '成功', 'success');
        this.props.onUpdatedService(resp.msg);
        this.props.closeModal();
      }
    });

    return false;
  }

  render()
  {
    const v = this.props.vehicle;
    return (
      <ModalScreen className="sem sem-term" show={true}
        title={`終止車輛服務 - ${v.cd_license}`}
        onClose={this.props.closeModal}>
        <Form className="sem-form" onSubmit={this.submitModal}>

          <label className="field">
            <strong>服務終止日</strong>
            <DatePicker selected={this.state.end_dtm} onChange={d=>this.setEndDate(d)}
                        dateFormat="yyyy-MM-dd" minDate={this.state.min_dtm} />
          </label>
          <label className="field">
            <strong>終止原因</strong>
            <select value={this.state.reason_id} onChange={e=>this.setState({reason_id: parseInt(e.target.value,10)})}>
              <option value="1">無抹/服務差</option>
              <option value="5">搬屋</option>
              <option value="2">離港/移民</option>
              <option value="3">撞車/劏車</option>
              <option value="4">欠款/公司停</option>
              <option value="0">其他</option>
            </select>
          </label>
          <label className="field">
            <strong>原因備註</strong>
            <textarea value={this.state.remarks} onChange={ e=>this.setState({remarks: e.target.value}) }></textarea>
          </label>

          <div className="error-msg">
            { this.state.error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={e=>this.props.closeModal()}>關閉</button>
            <button id="btn-submit" className="btn blue" >確定</button>
          </div>
        </Form>
      </ModalScreen>
    );
  }


}


export default TerminateServiceModal;